import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Alert,
    Box
} from '@mui/material';

export default function EditBarDialog({ open, onClose, onConfirm, bar }) {
    const [formData, setFormData] = useState({
        barName: '',
        phoneNumber: '',
        email: '',
        slug: ''
    });
    const [error, setError] = useState('');

    React.useEffect(() => {
        if (bar) {
            setFormData({
                barName: bar.barName || '',
                phoneNumber: bar.phoneNumber || '',
                email: bar.email || '',
                slug: bar.slug || ''
            });
        }
    }, [bar]);

    const handleSubmit = async () => {
        if (!formData.barName || !formData.phoneNumber || !formData.email) {
            setError('All fields are required');
            return;
        }
        onConfirm(formData);
    };

    if (!bar) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Edit Bar Information
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <TextField
                        fullWidth
                        label="Bar Name"
                        value={formData.barName}
                        onChange={(e) => setFormData({...formData, barName: e.target.value})}
                        margin="normal"
                        required
                    />
                    <TextField
                        fullWidth
                        label="URL Slug"
                        value={formData.slug}
                        onChange={(e) => setFormData({...formData, slug: e.target.value})}
                        margin="normal"
                        required
                        helperText="This will change the signup URL"
                    />
                    <TextField
                        fullWidth
                        label="Phone Number"
                        value={formData.phoneNumber}
                        onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
                        margin="normal"
                        required
                        helperText="Format: +1XXXXXXXXXX"
                    />
                    <TextField
                        fullWidth
                        label="Email"
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        margin="normal"
                        required
                    />
                </Box>
                {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button 
                    onClick={handleSubmit}
                    variant="contained" 
                    color="primary"
                >
                    Save Changes
                </Button>
            </DialogActions>
        </Dialog>
    );
} 